export default __webpack_public_path__ + "static/media/locationStamps.76f0161b.png";